import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import ConfirmModal from '../../components/ConfirmModal';
import { useNavigate } from 'react-router-dom';
import { createPrazoEntrega } from '../../services/prazoEntregaService';

const initialState = {
  nome: '',
  status: 'Ativo',
};

const PrazoEntregaCreate = () => {
  const [form, setForm] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const navigate = useNavigate();

  const handleChange = e => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    setError('');
    // Limpar erro do campo específico
    if (fieldErrors[name]) {
      setFieldErrors({ ...fieldErrors, [name]: '' });
    }
  };

  /**
   * Valida antes de abrir a confirmação: confirmar um cadastro que o
   * servidor vai recusar é uma ida e volta desperdiçada para o usuário.
   * @returns {Record<string,string>}
   */
  const validarCampos = () => {
    const erros = {};
    const nome = (form.nome || '').trim();

    if (!nome) erros.nome = 'Informe o nome do prazo de entrega.';
    else if (nome.length < 2) erros.nome = 'Nome deve ter pelo menos 2 caracteres.';

    if (!form.status) erros.status = 'Selecione o status.';

    return erros;
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const erros = validarCampos();
    if (Object.keys(erros).length > 0) {
      setFieldErrors(erros);
      setError('Corrija os campos destacados antes de salvar.');
      return;
    }

    setFieldErrors({});
    setError('');
    setShowConfirm(true);
  };

  return (
    <div className="w-full bg-white rounded shadow p-6 mt-6">
      <h2 className="text-xl font-bold mb-4">Cadastrar Prazo de Entrega</h2>
      {/* O estado `error` existia mas nunca era exibido na tela. */}
      {error && (
        <div role="alert" className="mb-4 rounded border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-700">
          {error}
        </div>
      )}
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">Nome *</label>
          <input
            type="text"
            name="nome"
            value={form.nome}
            onChange={handleChange}
            maxLength={50}
            className={`w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400 ${fieldErrors.nome ? 'border-red-500' : ''}`}
            placeholder="Nome do prazo de entrega"
          />
          {fieldErrors.nome && <p className="text-red-500 text-xs mt-1">{fieldErrors.nome}</p>}
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Status *</label>
          <select
            name="status"
            value={form.status}
            onChange={handleChange}
            className={`w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400 ${fieldErrors.status ? 'border-red-500' : ''}`}
          >
            <option value="Ativo">Ativo</option>
            <option value="Inativo">Inativo</option>
          </select>
          {fieldErrors.status && <p className="text-red-500 text-xs mt-1">{fieldErrors.status}</p>}
        </div>
        <div className="flex flex-row gap-1 justify-end mt-2 w-full overflow-x-auto">
          <button type="button" className="p-2 sm:px-4 sm:py-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-700 flex items-center gap-2 w-10 sm:w-auto justify-center" onClick={() => navigate('/prazo-entrega')}>
            <FontAwesomeIcon icon={faTimes} />
            <span className="hidden sm:inline">Cancelar</span>
          </button>
          <button type="submit" className="p-2 sm:px-4 sm:py-2 rounded bg-green-600 text-white font-semibold hover:bg-green-700 flex items-center gap-2 w-10 sm:w-auto justify-center" aria-label="Salvar">
            <FontAwesomeIcon icon={faSave} />
            <span className="hidden sm:inline">Salvar</span>
          </button>
        </div>
      </form>
      <ConfirmModal
        isOpen={showConfirm}
        title="Confirmar Cadastro"
        message="Deseja realmente cadastrar este prazo de entrega?"
        onCancel={() => setShowConfirm(false)}
        onConfirm={async () => {
          setShowConfirm(false);
          setLoading(true);
          setError('');
          setSuccess(false);
          try {
            await createPrazoEntrega(form);
            setLoading(false);
            setSuccess(true);
            setTimeout(() => navigate('/prazo-entrega'), 1200);
          } catch (err) {
            console.error('Erro ao cadastrar:', err);
            const errorData = err.response?.data;
            
            // Se houver erros de validação específicos dos campos
            if (errorData?.errors && Array.isArray(errorData.errors)) {
              const errors = {};
              errorData.errors.forEach(error => {
                if (error.path) {
                  if (!errors[error.path]) {
                    errors[error.path] = error.msg;
                  }
                }
              });
              setFieldErrors(errors);
            }
            setLoading(false);
          }
        }}
      />
    </div>
  );
};

export default PrazoEntregaCreate;
